<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item :label="$t('分类名称')" prop="categoryName">
                <a-input v-model="queryParam.categoryName" @pressEnter="handleQuery" :maxLength="32" :placeholder="$t('请输入')+$t('分类名称')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{$t('查询')}}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{$t('重置')}}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
        <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageVisible = false">
          <img alt="example" style="width: 100%" :src="previewUrl" />
        </a-modal>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd(topOptions)" v-hasPermi="['edu:category:add']">
          <a-icon type="plus" />{{$t('新增')}}
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form ref="createForm" @ok="getList" />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :bordered="tableBordered"
      >
        <template slot="categoryPic" slot-scope="text, record">
          <div>
            <img v-if="record.categoryPic" :src="record.categoryPic" style="width:50px;height:50px;" @click="handleRecordPreview(record.categoryPic)" alt="pic"/>
          </div>
        </template>
        <span slot="isVisible" slot-scope="text, record">
          {{ record.isVisible ? $t('是') : $t('否') }}
        </span>
        <span slot="isHomeVisible" slot-scope="text, record">
          {{ record.isHomeVisible ? $t('是') : $t('否') }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="$refs.createForm.handleUpdate(record, topOptions)" v-hasPermi="['edu:category:edit']">
             <a-icon type="edit" />{{$t('修改')}}
          </a>
          <a-divider type="vertical" v-hasPermi="['edu:category:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['edu:category:remove']">
            <a-icon type="delete" />{{$t('删除')}}
          </a>
        </span>
      </a-table>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { treeEduCategory, delEduCategory } from '@/api/edu/category'
import { mapGetters } from 'vuex'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'EduCategory',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      topOptions: [],
      previewImageVisible: false,
      previewUrl: '',
      loading: false,
      queryParam: {
        categoryName: null
      },
      columns: [
        {
          title: this.$t('分类名称'),
          dataIndex: 'categoryName',
          ellipsis: true
        },
        {
          title: this.$t('分类图片'),
          dataIndex: 'categoryPic',
          scopedSlots: { customRender: 'categoryPic' },
          align: 'center'
        },
        {
          title: this.$t('排序'),
          dataIndex: 'sort',
          align: 'center'
        },
        {
          title: this.$t('是否显示'),
          dataIndex: 'isVisible',
          scopedSlots: { customRender: 'isVisible' },
          align: 'center'
        },
        {
          title: this.$t('首页展示'),
          dataIndex: 'isHomeVisible',
          scopedSlots: { customRender: 'isHomeVisible' },
          align: 'center'
        },
        {
          title: this.$t('操作'),
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  created () {
    this.getList()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  methods: {
    /** 查询分类树 */
    getList () {
      this.loading = true
      treeEduCategory({ categoryName: this.queryParam.categoryName }).then(response => {
        const data = (response.data || []).map(item => {
          if (item.children && item.children.length === 0) {
            const { children, ...rest } = item
            return rest
          }
          return item
        })
        this.list = data
        this.topOptions = (response.data || []).map(item => ({ id: item.id, categoryName: item.categoryName }))
        this.loading = false
      })
    },
    handleQuery () {
      this.getList()
    },
    resetQuery () {
      this.queryParam = { categoryName: undefined }
      this.getList()
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      this.$confirm({
        title: this.$t('确认删除所选中数据'),
        content: this.$t('删除一级分类将同时删除其下的二级分类'),
        onOk () {
          return delEduCategory({ idList: [row.id] })
            .then(() => {
              that.getList()
              that.$message.success(that.$t('删除成功'), 3)
          })
        },
        onCancel () {}
      })
    }
  }
}
</script>
